// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".badge[data-v-f0d9da30]{transition:transform .3s ease}.badge[data-v-f0d9da30]:hover{transform:rotate(3deg)}.badge__link[data-v-f0d9da30]{width:252px;height:68px;margin:0;vertical-align:bottom;border-radius:19px;border:1px solid #328fe5}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
